// DaisyStack's patches to matestack-ui-vuejs 4.0.0.beta1, the JavaScript
// half of lib/lib/matestack_patches.rb. Import once, before
// MatestackUiVueJs.mount(appInstance):
//
//   import "daisy_stack/matestack_patches";
//
// It reaches into the component by path, so the app's esbuild alias must
// point matestack-ui-vuejs at the vue_js directory, not at its index.js:
//
//   --alias:matestack-ui-vuejs=./vendor/matestack-ui-vuejs/lib/matestack/ui/vue_js
import collectionFilter from "matestack-ui-vuejs/components/collection/filter";
// Not a matestack patch either: a failed Shell page transition becomes a full
// navigation instead of leaving the page dimmed. See shell_page_loading.js.
import matestackEventHub from "matestack-ui-vuejs/event_hub";
import { installShellPageLoading } from "./ui/layout/shell_page_loading.js";

if (typeof document !== "undefined") installShellPageLoading(matestackEventHub);

// Debounced, as-you-type perform() for the grid's filter kind: :search
// (DataGrid::Base#render_filter_control). A template expression can't call
// setTimeout itself (Vue 3's compiled handlers only see an allowlist of
// globals), so it needs a component method. One timer per filter instance,
// so several :search fields in one filter bar coalesce into one request.
collectionFilter.methods.debouncedPerform = function () {
  window.clearTimeout(this._searchDebounceTimer);
  this._searchDebounceTimer = window.setTimeout(() => this.perform(), 400);
};

// Filter defaults for the grid's filter bar (DataGrid::FilterForm passes
// `reset_values` as a prop: per filter key, the declared default or blank).
//
// created: Matestack loads filter state from the URL; a key the URL says
// nothing about (undefined) starts at its reset value, so a default shows as
// selected on first load. A key the URL does carry, even "" or [], is left
// alone: perform() writes explicit blanks to the URL, which is how a user
// clears a defaulted filter and keeps it cleared across reloads. A scalar
// from an old bookmark on a multiple filter is normalised to an array.
const copyValue = (value) => (Array.isArray(value) ? [...value] : value);

const originalCreated = collectionFilter.created;
collectionFilter.created = function () {
  if (originalCreated) originalCreated.apply(this, arguments);
  const resetValues = (this.props && this.props.reset_values) || {};
  Object.keys(resetValues).forEach((key) => {
    const reset = resetValues[key];
    const current = this.data[key];
    if (current === undefined) {
      this.data[key] = copyValue(reset);
    } else if (Array.isArray(reset) && !Array.isArray(current)) {
      this.data[key] = current === "" || current === null ? [] : [String(current)];
    }
  });
};

// resetFilter: Matestack drops every filter param from the URL (so the server
// applies defaults again); then show each control at its default or blank.
const originalResetFilter = collectionFilter.methods.resetFilter;
collectionFilter.methods.resetFilter = function () {
  originalResetFilter.apply(this, arguments);
  const resetValues = (this.props && this.props.reset_values) || {};
  Object.keys(resetValues).forEach((key) => {
    this.data[key] = copyValue(resetValues[key]);
  });
};
